<bz-button variant="tertiary" size="fit"
           class="show-button"
           appBringozIdGenerator="package-details-settings-button"
           [ariaLabel]="'View Settings' | translate"
           (clicked)="onOpen($event)">
  <bz-icon [icon]="icon"></bz-icon>
</bz-button>
